import { Icon, MenuItem } from '@chakra-ui/react';
import React from 'react'
import { SuccesToastWithText } from '../../../../Shared/ToastMessage/SuccessToast';
import { FiTrash } from 'react-icons/fi';
import { DataContext } from '../../../../../state/DataContext/DataContext';
import { DeleteBtnWithConfirmation } from '../../../../Shared/DeleteBtnWithConfirmation/DeleteBtnWithConfirmation';

interface IDeleteTaskBtn {
    afterDeleteFn?: any,
    TenantID: string,
    JobID: string,
    TaskID: string,
    renderBtn?: any,
}

export const DeleteTaskBtn = (props: IDeleteTaskBtn) => {
    const { actions } = React.useContext(DataContext);

    const deleteTask = (callback) => {
        actions.Task.DeleteTask(props.TenantID, props.JobID, props.TaskID).then(() => {
            SuccesToastWithText(`Task deleted succesfully!`);
        })
        if (props.afterDeleteFn) {
            props.afterDeleteFn();
        }
        callback();
    }

    return (
        <DeleteBtnWithConfirmation
            deleteFn={deleteTask}
            renderBtn={() => {
                return <MenuItem>
                    <Icon as={FiTrash} color="red.500" mr="1" mb="0" /> Delete
                </MenuItem>
            }}
            onClose={props.afterDeleteFn}

        />
    )
}
